import React, { useState } from 'react';
import { observer } from "mobx-react-lite";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ChatBox from "../../../../../elements/ChatBox/ChatBox";
import { ChatBoxWrapper, ChatContainer } from './ChatComponents.styled';

const minimalTheme = createTheme({
  palette: {
    background: {
      paper: 'transparent',
      default: 'transparent',
    },
  },
});

const ChatComponent = observer(({ 
  store, 
  customerSelected,
  agentId,
  agentDomain,
  inputWidth = "80vh",
  metadata = {},
  initialMessage = null,
  handleMetadata,
  agentData,
  children,
  initialContent
}) => {
  const [hasMessages, setHasMessages] = useState(false);

  const chatProps = {
    customerSelected,
    agentId,
    agentDomain: agentDomain || false,
    inputWidth: inputWidth,
    metadata: metadata,
    initialMessage: initialMessage,
    handleMetadata: handleMetadata,
    agentData,
  };

  const handleMessagesUpdate = (messages) => {
    if (messages && messages.length > 0 && !hasMessages) {
      setHasMessages(true);
    }
  };

  return (
    <ChatContainer>
      <ThemeProvider theme={minimalTheme}>
        <ChatBoxWrapper>
          {!hasMessages && (children || initialContent)}

          <ChatBox
            {...chatProps}
            onMessagesUpdate={handleMessagesUpdate}
          />
        </ChatBoxWrapper>
      </ThemeProvider>
    </ChatContainer>
  );

});

export default ChatComponent;
